<template>
	<div class="all_main">
		<myheader headTitle="个人信息"></myheader>
		<!-- <div class="all_height40 backgroundC_white display_flex">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 70%;padding-left: .8rem;margin: .8rem 0;">头像</span>
			<img src="@/assets/images/memberedit.svg" style="width:3rem; height: 3rem;margin: .5rem;" />
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: 1.6rem .8rem;" />
		</div> -->
		<div class="all_height_line24 backgroundC_white display_flex">
			<!-- :style="{'width':$store.state.userInfo.certifyWay === 0?'50%':'55%'}" -->
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 50%; padding-left: .8rem;">姓名</span>
			<!-- :style="{'width':$store.state.userInfo.certifyWay === 0?'18%':'13%',
				'background-color':$store.state.userInfo.certifyWay === 0?'#0277FC':'#66BE74'}" -->
			<span :style="{visibility:homeUrl?'hidden':'visible'}" class="text12 textcolorwhite all_line_height12 display_inline_block display_flex all_text_center"
				style="width:18%; margin: .6rem 0;border-radius: .2rem;justify-content:center" @click="toAuthSelf()"
				:class="{'passed':userInfo.certifyState===2,'nopassed':userInfo.certifyState!=2}">
				{{userInfo.certifyState === 2?'已认证':'立即认证'}}
			</span>
			<span class="text14 textcolor333 all_line_height24 display_inline_block all_text_right"
				style="width: 32%;padding-right: .8rem;">{{Tool.isNoEmpty(userInfo.staffName)?userInfo.staffName:'_'}}</span>
			<!-- <img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" /> -->
		</div>
		<div class="all_height_line24  backgroundC_white display_flex">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 40%;padding-left: .8rem;">手机号</span>
			<span class="text14 textcolor333 all_line_height24 display_inline_block all_text_right"
				style="width: 60%;padding-right: .8rem;">
				{{Tool.isNoEmpty(userInfo.mobile)?userInfo.mobile.replace(/^(\d{3})\d+(\d{4})$/,"$1****$2"):'_'}}
			</span>
			<!-- <img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" /> -->
		</div>
		<div class="all_height_line24  backgroundC_white display_flex">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 30%;padding-left: .8rem;">电子邮箱</span>
			<span class="text14 textcolor333 all_line_height24 display_inline_block all_text_right"
				style="width: 70%;padding-right: .8rem;">
				{{Tool.isNoEmpty(userInfo.email)?userInfo.email.replace(/^(\d{6})\d+(\d{4})$/, '$1********$2'):'_'}}
			</span>
			<!-- <img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" /> -->
		</div>
		<div class="all_height_line24  backgroundC_white display_flex">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 52%;padding-left: .8rem;">用户账号/统一身份认证账号</span>
			<span class="text14 textcolor333 all_line_height24 display_inline_block all_text_right"
				style="width: 48%;padding-right: .8rem;">
				{{Tool.isNoEmpty(userInfo.identityAccount)?userInfo.identityAccount:'_'}}
			</span>
			<!-- <img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" /> -->
		</div>
		<!-- 	<div class="all_height_line24 margin_top_10 backgroundC_white display_flex">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 90%;padding-left: .8rem;">组织机构</span>
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
		</div> -->
		<div class="all_height_line24 backgroundC_white display_flex margin_top_10">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 30%;padding-left: .8rem;">账号类型</span>
			<span class="text14 textcolor333 all_line_height24 display_inline_block all_text_right"
				style="width: 70%;padding-right: .8rem;">
				{{getStaffTypeText()}}
			</span>
			<!-- 0-超级管理员,1-管理员,2-企业管理员,3-企业用户,4,一般用户 -->
			<!-- <img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" /> -->
		</div>
		<!-- <div class="all_height_line24 margin_top_10 backgroundC_white display_flex">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 90%;padding-left: .8rem;">邮寄地址</span>
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
		</div> -->
	</div>
</template>

<script>
	export default {
		name: "userInfo",
		data() {
			return {
				userInfo: {
					//认证状态
					certifyWay: 0,
					//姓名
					staffName: '',
					//手机号
					mobile: '',
					//邮箱
					email: '',
					//统一账号
					identityAccount: '',
					//
					homeUrl: '',
				}
			};
		},
		mounted() {
			this.homeUrl = window.localStorage.getItem("HomeUrl")
			this.getUserInfo()
		},
		methods: {
			//获取账号类型文本
			getStaffTypeText() {
				switch (this.$store.state.userInfo.staffType) {
					case 0:
						return '超级管理员'
						break;
					case 1:
						return '管理员'
						break;
					case 2:
						return '企业管理员'
						break;
					case 3:
						return '企业用户'
						break;
					case 4:
						return '一般用户'
						break;
				}
			},
			//个人认证
			toAuthSelf() {
				// this.$router.push({
				// 	path: 'personalauthflow',
				// });
				if (this.$store.state.userInfo.certifyState !== 2) {
					this.$router.push({
						path: 'personalauthflow',
					});
				}
			},
			//获取个人信息
			getUserInfo() {
				//console.log(this.$parent)
				if (!this.$store.state.userInfo) {
					this.$store.dispatch(this.$LoadShow, true)
					this.$post("/staff/api/info")
						.then((res) => {
							this.$store.dispatch(this.$LoadShow, false)
							if (res.success && res.data) {
								this.userInfo = res.data
								this.$store.dispatch("actionUserInfo", res.data);
							}
						});
				} else {
					this.userInfo = this.$store.state.userInfo
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.passed {
		color: #66BE74;
		border: 1px solid #66BE74;
	}

	.passed::before {
		content: url('../../assets/images/personal_auth.svg');
		display: inline-block;
		width: .8rem;
		height: .8rem;
		margin-right: .3rem;
		transform: scale(0.5);
	}

	.nopassed {
		color: #FFF;
		background-color: #0277FC;
	}
</style>